import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { BeforeAfter } from "./components/BeforeAfter";
import { Identify } from "./components/Identify";
import { Includes } from "./components/Includes";
import { Tomos } from "./components/Tomos";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { About } from "./components/About";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
export function App() {
  return <div className="w-full bg-white text-[#0f2547]" data-id="element-0" data-mp="2wjgq7g0cxrfd">
      <MetaPixel data-id="element-1" data-mp="2whx8rm2ytac0" />
      <main className="w-full" data-id="element-2" data-mp="28ufqch5lbolp">
        <Hero data-id="element-3" data-mp="28tme50nv46w6" />
        <BeforeAfter data-id="element-4" data-mp="28t4lsf4bmctj" />
        <Identify data-id="element-5" data-mp="28sl5t3y8dyi5" />
        <Includes data-id="element-6" data-mp="28s30zixi6bym" />
        <Tomos data-id="element-7" data-mp="23vkzcrxgytqi" />
        <Bonuses data-id="element-8" data-mp="23w4ek0vqj40u" />
        <Offer data-id="element-9" data-mp="23ujl6el5pr4k" />
        <Guarantee data-id="element-10" data-mp="23v2sl1d6kx4c" />
        <Testimonials data-id="element-11" data-mp="23ti67z10skhk" />
        <About data-id="element-12" data-mp="3ikh7o8icgqyg" />
        <Faq data-id="element-13" data-mp="3iiwdijzxza14" />
        <FinalCta data-id="element-14" data-mp="3ij65ue8glt9z" />
      </main>
      <FloatingCta data-id="element-15" data-mp="3ihuyy5jpw5en" />
    </div>;
}